import { Validators } from "@angular/forms";
import { Profile } from "./profile-model";
import { User } from "./user-model";
import { Studio } from "./studio-model";
import { Reservation } from "./reservation-model";
import { Invoice } from "./invoice-model";
import { Prestation } from "./prestation-model";
import { OpeningSlotsComponent } from "../pages/manager-studio/opening-slots/opening-slots.component";
import { OpeningSlot } from "./opening-slot-model";

export class CustomPage {
  endpoint: string = "";
  route: string = "";
  title: string = "";
  custom_route: string = "";
  filters: string = "";

  constructor(
    endpoint: string,
    route: string,
    title: string,
    custom_route: string,
    filters: string
  ) {
    this.endpoint = endpoint;
    this.route = route == "" ? endpoint : route;
    this.title = title;
    this.custom_route = custom_route;
    this.filters = filters;
  }

  static get_form_datas(endpoint: string): any {
    let object = {
      form_builder: {},
      inputs: [],
      relations: [],
      title: "",
      model: null,
    };
    switch (endpoint) {
      case "users": {
        object = {
          form_builder: User.get_form(),
          inputs: User.get_inputs(),
          relations: User.get_relations(),
          title: User.get_title(),
          model: User,
        };
        break;
      }
      case "profiles": {
        object = {
          form_builder: Profile.get_form(),
          inputs: Profile.get_inputs(),
          relations: Profile.get_relations(),
          title: Profile.get_title(),
          model: Profile,
        };
        break;
      }
      case "studios": {
        object = {
          form_builder: Studio.get_form(),
          inputs: Studio.get_inputs(),
          relations: Studio.get_relations(),
          title: Studio.get_title(),
          model: Studio,
        };
        break;
      }
      case "reservations": {
        object = {
          form_builder: Reservation.get_form(),
          inputs: Reservation.get_inputs(),
          relations: Reservation.get_relations(),
          title: Reservation.get_title(),
          model: Reservation,
        };
        break;
      }
      case "invoices": {
        object = {
          form_builder: Invoice.get_form(),
          inputs: Invoice.get_inputs(),
          relations: Invoice.get_relations(),
          title: Invoice.get_title(),
          model: Invoice,
        };
        break;
      }
      case "opening-slots": {
        object = {
          form_builder: OpeningSlot.get_form(),
          inputs: OpeningSlot.get_inputs(),
          relations: OpeningSlot.get_relations(),
          title: OpeningSlot.get_title(),
          model: OpeningSlot,
        };
        break;
      }
      default: {
        object = {
          form_builder: {},
          inputs: [],
          relations: [],
          title: "",
          model: null,
        };
        break;
      }
    }
    return object;
  }
}
